import { createRouter, createWebHistory } from "vue-router";
import { allRoute } from "@/router/routes";
import { hasPermission } from "@/helpers/permissions";
import { getSession, clearSession, sessionReady } from "@/stores/session";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({ showSpinner: false });

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoute,
});

// Nothing is decided until the app knows who is signed in at this address.
router.beforeEach(async () => {
  await sessionReady();
});

router.beforeEach((to, from, next) => {
  const requiredPermission = to.meta.permission;

  // Only somebody signed in can lack a permission; anybody else is sent to
  // sign in by the guard below, then brought back here.
  if (requiredPermission && getSession().signedIn && !hasPermission(requiredPermission)) {
    return next({ name: "error.403" });
  }
  const title = to.meta.title;
  if (title) {
    document.title = title.toString();
  }
  next();
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  NProgress.start();
  const previousPath = routeTo.fullPath;

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  // The session was checked with the API as the app opened (restoreSession).
  if (!getSession().signedIn) {
    return redirectToLogin(previousPath);
  }
  // The admin address's home is the admin dashboard, not a company's.
  if (routeTo.name === "dashboards.hr" && getSession().scope === "admin") {
    return next({ name: "dashboards.admin" });
  }
  return next();
});

router.afterEach(() => {
  NProgress.done();
});

const redirectToLogin = (previousPath: any) => {
  clearSession();
  NProgress.done();
  router.push({
    name: "auth.sign-in",
    query: { redirectedFrom: previousPath },
  });
};

export default router;
